import { Grid, Typography } from "@material-ui/core";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { PlaceHolders } from "../../../../helpers/Constants";

const DevelopmentSettings = ({ classes, data, onUpdate }: any) => {
    const { t: translator } = useTranslation();

    return (<Grid container spacing={3} className={clsx(classes.p15)}>
        <Grid item md={12} className={classes.w100}>
            <Typography title={translator("landingPages.CSSDesign")} className={classes.alignDir}>
                {translator("landingPages.CSSDesign")}
            </Typography>
            <textarea
                placeholder={PlaceHolders.CSS_STYLE}
                maxLength={1000}
                id="yourMessage"
                style={{ direction: 'ltr' }}
                className={clsx(classes.textarea, classes.sidebar)}
                onChange={(e: any) => onUpdate({ ...data, ClientCssStyle: e.target.value })}
                value={data.ClientCssStyle}
            ></textarea>
        </Grid>
    </Grid>)
}

export default DevelopmentSettings;
